import React, {useEffect, useState} from "react";
import Categories from "./components/categories/Categoris";
import MenuItemModal from "./components/Item";
import getMenuService from "./services/getMenuService";
import Menu from "./components/Menu";
import config from './config';

function App() {
    const [menuItemsJson, setMenuItemsJson] = useState();
    const [menuJson, setMenuJson] = useState();

    function fetchMenu(slugFilter) {
        getMenuService(slugFilter).then(response => {
            setMenuItemsJson(response?.data?.Categories);
            setMenuJson(response?.data?.Categories[0]);
        }).catch(error => {
            return error
        });
    }

    useEffect(() => {
        fetchMenu(config.apiSlug);
    }, []);

    const [showModal, setShowModal] = useState(false);
    const [modalProps, setModalProps] = useState();

    const toggleModal = async (item) => {
        setMenuJson(menuItemsJson.filter(x => x.MenuCategoryId === item.menuCategoryId)?.[0]);
    }

    return (
        <div className='grid w-full h-full bg-fms-background'>
            <div className='flex w-full h-fms-mobileView-category-height md:h-fms-category-height overflow-auto'>
                <Categories toggleModal={toggleModal} categoryList={menuItemsJson}/>
            </div>
            <div className='w-full h-full md:grid md:grid-cols-2 bg-fms-menu-background p-4'>

                {menuJson?.MenuItemes?.map((item) =>
                    <div onClick={() => {
                        setShowModal(!showModal);
                        setModalProps({
                            Title: item.Name,
                            Reception: item.Description,
                            Price: item.Price,
                            Star: null,
                            Tags: null,
                            Image: item.Image
                        });
                    }}>

                        <div className='m-1'>
                            <Menu key={1} menuItem={{
                                Title: item.Name,
                                Reception: item.Description,
                                Price: item.Price,
                                Star: null,
                                Tags: null,
                                Image: item.Image
                            }}/>
                        </div>
                    </div>
                )}
            </div>

            <MenuItemModal
                show={showModal}
                modalProps={modalProps}
                onHide={() => {
                    setShowModal(false);
                }}
            />
        </div>
    );
}

export default App;